// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j5Kj","questions":"styles_questions__2ZXmW","footer":"styles_footer__A9Nme"};